import { getItem } from '@/tools';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import translation_en from './en.json';
import translation_zh from './zh.json';

const resources = {
  en: {
    translation: translation_en,
  },
  zh: {
    translation: translation_zh,
  },
};

const lang = getItem('lang');

i18n.use(initReactI18next).init({
  resources,
  lng: lang || 'en',
  fallbackLng: 'en', // use en if detected lng is not available
  interpolation: {
    escapeValue: false, // react already safes from xss
  },
});

export default i18n;
